import {Button, Typography} from '@material-ui/core'
import {useReportsFolderSidebarContext} from 'modules/reports/components/Folder/Sidebar/ReportsFolderSidebar.context'
import ReportFolder from 'modules/reports/models/ReportFolder'
import React from 'react'
import ReportsFolderSidebarItemMenu from './Menu'
import useStyles from './ReportsFolderSidebarItem.styles'

type Props = {
  folder?: ReportFolder
  children?: React.ReactNode
  onClick?: (folder?: ReportFolder) => void
  'data-testid'?: string
}

function ReportsFolderSidebarItem(props: Props) {
  const {folder, children, onClick} = props
  const folderSidebarContext = useReportsFolderSidebarContext()
  const selected = folder && folderSidebarContext.folderId === folder.id
  const classes = useStyles({selected})

  function handleClick() {
    const clickCallback = onClick || folderSidebarContext.onSelect
    clickCallback(folder as ReportFolder)
  }

  return (
    <div className={classes.container}>
      <Button
        onClick={handleClick}
        className={`${classes.button} ${classes.root}`}
        data-testid={props['data-testid']}
        disableRipple={!folder}
      >
        <Typography variant="h6" component="h2" className={classes.typography}>
          {children || (folder && folder.name)}
        </Typography>
      </Button>

      {folder && selected && <ReportsFolderSidebarItemMenu folder={folder} />}
    </div>
  )
}

export default ReportsFolderSidebarItem
